import SEO from '../../components/SEO';
import BannerMask from '../../components/BannerMask';
import { Container } from 'reactstrap';
import InnerBanner from '../../components/InnerBanner';
import SectionHeader from '../../components/SectionHeader';
import TwoLayoutSection from '../../components/TwoLayoutSection';
import { lawFirmsDatas } from '../../constants/lawFirmsDatas';

const Lawyer = () => {
  return (
    <>
      <SEO title="Lawyers" />
      <div className="resource">
        <InnerBanner
          title="Lawyers"
          description="Legalligence offers AI-assisted legal research and smart drafting services to help save time and enhance efficiency. Our platform streamlines complex legal workflows, reduces manual effort, and ensures accuracy across case research and document creation."
        />
        <section className="section-gap-lg">
          <Container>
            <SectionHeader title="For Law Firms & Legal Professionals" />
            <TwoLayoutSection data={lawFirmsDatas} />
          </Container>
        </section>
      </div>
    </>
  );
};

export default Lawyer;
